import styled from "styled-components";

export const AuthorLabel = styled.label`
color: ${(props) => `#FFFFFF`};
background-color: ${(props) => `#75797B`};
font-weight: bold;
font-size: 12px;
`;